import { routeTo, finish, openModal } from '../../core/actions';
import { registerFlow } from '../../core/flow-register';
import FlowHeader from '../../components/FlowHeader/FlowHeader';
import FooterSite from '../../components/FooterSite/FooterSite';
import BaseLayout from '../../components/BaseLayout/BaseLayout';
import InternalAuthenticator from '../../components/BaseLayout/InternalAuthenticator';
import BrokerageAccountSelectionScreen from '../../screens/BrokerageAccountSelectionScreen/BrokerageAccountSelectionScreen';
import FONASUAccountFinderLandingScreen from '../../screens/FONASUAccountFinderLandingScreen/FONASUAccountFinderLandingScreen';
import FONASUBRKCredentialsScreen from '../../screens/FONASUBRKCredentialsScreen/FONASUBRKCredentialsScreen';
import MFAccountFinderScreen from '../../screens/MFAccountFinderScreen/MFAccountFinderScreen';
import CredentialsValidationModal from '../../components/CredentialsValidationModal/CredentialsValidationModal';
import { FlowNode } from '../../core/types/flow';
import { contactTextFn } from '../shared/utils';
import {
  isUserNameMissing,
  isUsernameAlreadyTaken,
  isUsernameCreationFailed,
  usernameValidation
} from '../shared/testers';
import {
  loadBPId,
  loadCustomer,
  commitBrokerageAccountSelection,
  commitBRKFONASUUserName,
  routeUserToInternalAccFinder
} from './loaders';

const nodes: Array<FlowNode> = [
  {
    route: 'start',
    screen: FONASUAccountFinderLandingScreen,
    load: loadBPId,
    commit: routeUserToInternalAccFinder,
    form: [{ name: 'accountTypeOption', required: true }],
    next: {
      default: finish()
    }
  },
  {
    route: 'mutual-funds',
    screen: MFAccountFinderScreen,
    form: [
      {
        name: 'productType'
      },
      {
        name: 'accountType'
      },
      { name: 'account', required: true }
    ],
    next: {
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'MutualFundAccountFinder'
      }
    }
  },
  {
    route: 'brokerage',
    screen: BrokerageAccountSelectionScreen,
    load: loadCustomer,
    commit: commitBrokerageAccountSelection,
    form: [{ name: 'investmentGoal' }, { name: 'applicationType' }],
    next: {
      cases: [[isUserNameMissing, routeTo('brkCredentials')]],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'BrokerageAccountFinder'
      }
    }
  },
  {
    route: 'brkCredentials',
    screen: FONASUBRKCredentialsScreen,
    commit: commitBRKFONASUUserName,
    form: [
      {
        name: 'username',
        validation: usernameValidation
      }
    ],
    next: {
      cases: [
        [isUsernameAlreadyTaken, openModal(CredentialsValidationModal)],
        [isUsernameCreationFailed, openModal(CredentialsValidationModal)]
      ],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'BrokerageCredentials'
      }
    }
  }
];

export default registerFlow({
  namespace: 'front-office/account-finder',
  nodes,
  start: 'start',
  pageDecorators: [BaseLayout, InternalAuthenticator],
  flowProps: {
    getContactText: contactTextFn(),
    header: FlowHeader,
    footer: FooterSite
  }
});
